














import AdminService from '@/api/AdminService';
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ImpersonateBar extends Vue {
  adminService = new AdminService();

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get adminCredentials() {
    const businessInfo = this.$store.getters['business/getBusinessInfo'] && this.$store.getters['business/getBusinessInfo'].business;
    return {
      fullname: (businessInfo && businessInfo.loggedInManager && businessInfo.loggedInManager.fullname) || 'Super Admin',
      business: {
        name: (businessInfo && businessInfo.name) || ''
      }
    };
  }

  disableImpersonate() {
    this.adminService.disableImpersonate().then(res => {
      if (res && res.data) {
        window.location.assign('/admin/businesses');
      }
    });
  }
}
